<template>
  <custom-dialog
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    width="1000px"
    class="bind-part-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item style="float:right; margin-right: 0;">
            <search-input
              v-model="formSearch.search"
              @fetch="onPageChange({ page: 1 })"
              :placeholder="i18n.placeholder_part_name_part_code"
            ></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          v-model="selectedData"
          :data="tableList"
          :tableCode="tableCode"
          @filter="filterChange"
          @sort="sortChange"
          height="400px"
          type="checkbox"
        ></custom-table>
      </div>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{i18n.com_cancel}}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{i18n.com_confirm}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/**
 * 添加零件
 */
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    // model: {
    //   data: {
    //     orderDeviceId: '', // 必填
    //     productCode: '', // 必填
    //   }
    // }
  },
  data() {
    return {
      tableCode: 'proposal_carry_part_unselected',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
      },
      totalRows: 0,
      tableList: [],
      selectedData: [],
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.caseOrderPartSelectPage, {
        ...this.formSearch,
        orderDeviceId: this.model.data.orderDeviceId,
        productCode: this.model.data.productCode,
      }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onConfirm() {
      this.$postJSON(apis.caseOrderPartSave, this.getReqData(), true).then(() => {
        this.$message({
          message: this.i18n.com_handle_success,
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    getReqData() {
      return {
        orderDeviceId: this.model.data.orderDeviceId,
        partList: this.selectedData,
      };
    },
    closeDialog() {
      this.visible = false;
    },
  },
  created() {},
  mounted() {
    this.getTableList();
  },
};
</script>

<style lang="scss" scoped>
.bind-part-dialog {
  .dialog-body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
